import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authLogout, stgAuthLogout } from 'src/clients';
import { clearAuth } from 'src/redux/actions';
import { getAuth } from 'src/redux/selectors';
import { mutate } from 'swr';

type DoLogoutParams = {
  from?: string;
};

export const useLogout = () => {
  const auth = useSelector(getAuth);
  const dispatch = useDispatch();

  const clearCache = () => mutate(() => true, undefined, { revalidate: false });

  const doLogout = useCallback(
    async ({ from }: DoLogoutParams = {}) => {
      if (from) {
        AnalyticsManager.instance().track(AnalyticsEvent.click_logout, {
          from,
        });
      }

      dispatch({ type: 'RESET_ENV' });

      if (!auth.isSessionExpired) {
        try {
          const promises: Promise<any>[] = [];
          if (auth.usernameStaging && auth.tokenStaging) {
            promises.push(stgAuthLogout());
          }
          promises.push(authLogout());
          await Promise.all(promises);
          // eslint-disable-next-line no-empty
        } catch {}
      }

      clearCache();
      indexedDB.deleteDatabase('oy-desktop');
      dispatch(clearAuth());
      window.location.href = '/login';
    },
    [auth.isSessionExpired, auth.tokenStaging, auth.usernameStaging, dispatch],
  );

  return { doLogout };
};
